import TitleBlock from '@anm/components/TitleBlock';
import Button from '@anm/components/buttons/Button';
import getFromCdn from '@anm/helpers/getFromCdn';
import { flexCenter } from '@anm/styles/helpers';
import { FC } from 'react';
import styled from 'styled-components';

export type BackgroundContactUsSectionProps = {
  href: string;
  title: string;
  description?: string;
};

const Wrapper = styled.div`
  ${flexCenter};
  flex-direction: column;
  background-image: url(${getFromCdn('images/enterprise-3@2x.jpg')});
  background-size: cover;
  background-color: #dbc3f7;
  background-repeat: no-repeat;
  background-position: bottom center;
  padding: 35px 30px;
  border-radius: 5px;
  margin-top: 81px;
`;

const BackgroundContactUsTitleBlock = styled(TitleBlock)`
  width: auto;
  text-align: center;
  margin-bottom: 17px;
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: 39px;
    margin-bottom: 6px;
  }
`;

const BackgroundContactUsSection: FC<BackgroundContactUsSectionProps> = ({
  href,
  title,
  description
}) => (
  <Wrapper>
    <BackgroundContactUsTitleBlock
      {...{ title, description }}
      size="super-medium"
    />
    <Button href={href} size="large" variant="white-to-light-blue">
      Contact Us
    </Button>
  </Wrapper>
);

export default BackgroundContactUsSection;
